import { Box, Grid, Typography, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Paper, Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useDispatch } from 'react-redux';
import { useState, useEffect, ChangeEvent } from 'react';
import AddIcon from '@mui/icons-material/Add';

const useStyles = () => ({
  gridItem: { margin: 8 },
  table: {
    minWidth: 650,
  },
  tableContainer: {
    margin: 8,
    maxHeight: 440,
  },
  addButton: {
    margin: '16px 8px',
  }
});

interface LoteData {
  numeroLote: string;
  dataFabricacao: string;
  dataExpiracao: string;
}

interface FormData {
  lotes: LoteData[];
}

export default function InformacoesLotes() {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  // Inicializa uma tabela com 20 linhas vazias
  const initialLotes = Array(20).fill(null).map((_, index) => ({
    numeroLote: '',
    dataFabricacao: '',
    dataExpiracao: ''
  }));
  
  const [formData, setFormData] = useState<FormData>({
    lotes: initialLotes
  });

  // Função para adicionar mais uma linha na tabela
  const adicionarLinha = () => {
    setFormData({
      ...formData,
      lotes: [
        ...formData.lotes,
        {
          numeroLote: '',
          dataFabricacao: '',
          dataExpiracao: ''
        }
      ]
    });
  };

  const handleChange = (index: number, field: keyof LoteData, value: string) => {
    const updatedLotes = [...formData.lotes];
    updatedLotes[index] = {
      ...updatedLotes[index],
      [field]: value
    };
    
    setFormData({
      ...formData,
      lotes: updatedLotes
    });
  };

  useEffect(() => {
    dispatch({
      type: 'dadosLotes',
      payload: { dadosLotes: formData }
    });
  }, [formData, dispatch]);

  return (
    <Box>
      <Typography variant="h5" style={{ margin: 15 }}>
        INFORMAÇÕES DOS LOTES
      </Typography>

      <TableContainer component={Paper} style={classes.tableContainer}>
        <Table style={classes.table} stickyHeader aria-label="tabela de lotes">
          <TableHead>
            <TableRow>
              <TableCell align="center">N.º de ordem</TableCell>
              <TableCell align="center">Número de lote</TableCell>
              <TableCell align="center">Data da fabricação</TableCell>
              <TableCell align="center">Data de expiração</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formData.lotes.map((lote, index) => (
              <TableRow key={index}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">
                  <TextField
                    size="small"
                    variant="outlined"
                    value={lote.numeroLote}
                    onChange={(e) => handleChange(index, 'numeroLote', e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    type="date"
                    size="small"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={lote.dataFabricacao}
                    onChange={(e) => handleChange(index, 'dataFabricacao', e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    type="date"
                    size="small"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={lote.dataExpiracao}
                    onChange={(e) => handleChange(index, 'dataExpiracao', e.target.value)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={adicionarLinha}
        style={classes.addButton}
      >
        Adicionar Lote
      </Button>
    </Box>
  );
}